import { PrecioAdicional } from "./precio_adicional";

export class TipoPrecio{
    public constructor(
        public id: String = "",
        public nombre:String = "",
        public usuario_id:String = null,
        public empresa_id:String ="",
        public editar: boolean = false,
        public precios: Array<PrecioAdicional> = [],

        public tipo_precio_id = "",
        public is_new: boolean = true,
    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/tipo_precio.ts